const aDudaSupportedLanguage = [
    'en', 'es', 'ja', 'pt', 'fr', 'de', 'tr', 'en-gb', 'it', 'nl', 'ar', 'be', 'bg', 'bs-ba', 'ca', 'cs',
    'da', 'el', 'en-au', 'en-ca', 'es-ar', 'es-cl', 'es-co', 'es-cr', 'es-mx', 'et', 'fa', 'fi',
    'fr-ca', 'he', 'hi', 'lv', 'hu', 'hy', 'id', 'is', 'nb', 'pa', 'pl', 'pt-br', 'ro', 'ru', 'sk', 'sl',
    'sq', 'sv', 'sw', 'ta', 'th', 'uk', 'vi', 'zh', 'cy', 'tl', 'zh-tw', 'ka', 'mr', 'sr-rs', 'gl',
    'eu', 'az', 'ps', 'mi', 'ko', 'mn'
];

function detectLocaleFromPath(path = '', locales = []) {
    const firstSegment = path?.split('/')[0]?.toLowerCase();
    return locales.includes(firstSegment) ? firstSegment : null;
}

export function setProductLink(product, { dudaConfig, navDetailsExist/* , seoCollection */ }) {

    const currentPage = dudaConfig?.page?.toLowerCase() || ''; /* DudaConfig.local is giving en even we have chosen the en-gb and hence we need this logic */
    const matchedLocale = detectLocaleFromPath(currentPage, aDudaSupportedLanguage);
    const sLocalLanguage = matchedLocale || dudaConfig?.locale?.toLowerCase() || 'en';
    const isLocalized = currentPage.startsWith(`${sLocalLanguage}/`);
    const rootURL = isLocalized ? `/${sLocalLanguage}` : '';

    // const sLocalLanguage = dudaConfig?.locale || window?.Parameters?.currentLocale || 'en';
    // const isLocalized = dudaConfig?.page?.includes(`${sLocalLanguage}/`); /* to check if already localized means already showing in local language or default language */
    // const rootURL = isLocalized ? `/${sLocalLanguage}` : ''; /* if localized then add language in the page url */

    try {
        if (navDetailsExist && product?.page_item_url_slug) {
            return `${rootURL}/product/${product?.page_item_url_slug}`; /* SEO friendly */
        } else {
            return `${rootURL}/details?id=${product._id}`; /* Non SEO friendly */
        }

    } catch (e) {
        console.error('Error in setProductLink: ', e);
        if (product?._id) return `${rootURL}/details?id=${product._id}`; /* Non SEO friendly */
    }
}

export function handleNavLinksAndSeo({ navLinks, dudaConfig }) {
    try {
        // const navLinks = await window?.dmAPI?.getNavItemsAsync();
        const bIsNavDetailExist = navLinks?.filter(n => {
            const sLocalLanguage = dudaConfig?.locale || window?.Parameters?.currentLocale || 'en';
            const isLocalized = dudaConfig?.page?.includes(`${sLocalLanguage}/`); /* to check if already localized means already showing in local language or default language */
            const sAlias = isLocalized ? `${sLocalLanguage}/product/~page-item~` : 'product/~page-item~';
            if (n.alias == sAlias) {
                return true;
            } else if (n.subNav && n.subNav.length > 0) {
                let navDetail = n?.subNav?.filter(nav => nav?.alias == sAlias);
                return navDetail?.length > 0 ? true : false;
            } else {
                return false;
            }
        })?.length ? true : false;

        return bIsNavDetailExist;
    } catch (e) {
        console.error('Error in handleNavLinksAndSeo: ', e, e?.stack);
        return false;
    }
}

export async function getSEOCollectionDetail(oBody) {
    try {
        const { aBusinessProductId/* , perPage, page */ } = oBody;
        if (!window.dmAPI || !window.dmAPI.loadCollectionsAPI) {
            console.error("dmAPI not available");
            return null;
        }

        // const aTestingCollectionData = await window?.dmAPI?.getCollection({ collectionName: 'SEOCollection-1' }) || [];

        // const nPageNumber = page - 1;
        const collection = await window.dmAPI.loadCollectionsAPI();

        const aSEOCollection = await collection
            .data("SEOCollection-1")
            .where("iBusinessProductId", "IN", aBusinessProductId)
            .orderBy("_id", "asc")
            .pageSize(aBusinessProductId?.length || 30)
            .pageNumber(0) /* we always get which details we need irrespective of the page */
            .get();
        if (aSEOCollection?.values?.length) return aSEOCollection.values;
        else return [];

    } catch (e) {
        console.error('[SERVICE] 108: Error in getSEOCollectionDetail: ', e, e?.stack);
        return [];
    }
}

export function mapSEOCollectionToBusinessProduct({ aSEOCollection, products }) {
    try {
        if (aSEOCollection?.length) {
            aSEOCollection.forEach((oSEOCollection) => {
                const iBusinessProductId = oSEOCollection?.data?.iBusinessProductId.toString();
                const nProductIndex = products.findIndex((item) => item._id.toString() === iBusinessProductId);
                if (nProductIndex !== -1) {
                    products[nProductIndex].page_item_url_slug = oSEOCollection.page_item_url;
                    products[nProductIndex].bIsSyncUp = true; /* Testing purpose */
                    /* For future */
                    // products[nProductIndex].sMetaDescription = product.sMetaDescription;
                    // products[nProductIndex].sMetaTitle = product.sMetaTitle;
                    // products[nProductIndex].sMetaKeywords = product.sMetaKeywords;
                }
            });
        }
    } catch (error) {
        console.error("Error mapping SEO collection to business product:", error, error?.stack);
    }
}